if (!customElements.get('crosssell-form-checker')) {
  class CrossSellFormChecker extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this))
    }

    handleClick(event) {
      const button = event.target.closest('button[data-crosssell-add-button]');
      if (!button) return;

      const wrapper = button.closest('product-form');
      const select = wrapper?.querySelector('[data-crosssell-select]');

      if (!select) return;

      const selectedValue = select.value;
      if (!selectedValue) {
        select.classList.add('tw-select-error');
        button.setAttribute('disabled', 'disabled');
        select.focus();
      } else {
        select.classList.remove('tw-select-error');
        button.removeAttribute('disabled');
      }
    }
  }

  customElements.define('crosssell-form-checker', CrossSellFormChecker);
}
